import sertifikat1 from "../../Assets/certif/sertifikat1.png";
import sertifikat2 from "../../Assets/certif/sertifikat2.png";
import sertifikat3 from "../../Assets/certif/sertifikat3.jpg";
import sertifikat4 from "../../Assets/certif/sertifikat4.jpg";
import attendance1 from "../../Assets/certif/attendance1.jpg";
import attendance2 from "../../Assets/certif/attendance2.jpg";

const certificates = [
  {
    image: sertifikat1,
    year: "2025",
    description: "Basic Python Programming - Dicoding",
  },
  {
    image: sertifikat2,
    year: "2025",
    description: "Basic Artificial Intelligence - Dicoding",
  },
  {
    image: attendance1,
    year: "2024",
    description: "Google Devfest Participants - GDG Surabaya",
  },
  {
    image: sertifikat3,
    year: "2024",
    description: "Cyber Security Awareness Course - YPT",
  },
  {
    image: sertifikat4,
    year: "2023",
    description: "Schematics National Logic Competition - ITS",
  },
  {
    image: attendance2,
    year: "2023",
    description: "1000 Digital Startup Participants - Kominfo",
  },
];

export default certificates;
